import styled from 'styled-components';

//components
import $Icon from 'components/Icon';

//constants
const gutter = 8;

export const Tag = styled.div`
  height: 24px;
  align-items: center;
  background: #ececec;
  border-radius: 2px;
  color: #333330;
  display: inline-flex;
  font-size: 14px;
  line-height: 18px;
  padding: 0 12px;
  cursor: default;

  ${p =>
    p.onClick &&
    `
    cursor: pointer;
    transition: 0.2s background ease-out;

    &:hover {
      transition: none;
    }
  `}
`;

export const TagName = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const StyledIcon = styled($Icon)`
  color: ${p => p.theme.buttonColor};
  margin-left: 5px;
`;
